module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '9n6upoz9',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
